import React, { useRef, useState, useEffect } from 'react';
import Konva from 'konva';
import { Stage, Layer, Rect, Group, Circle, Line, Path } from 'react-konva';

import InstructionsHand from '../svg/InstructionsHand';

const StackItInstructionsCanvas = (props) => {
	let refs = useRef([]);

	const canvas_size = 220;

	let hand_in_anim;
	let hand_out_anim;

	const killAllFrameAnimations = () => {
		if(hand_in_anim != null && hand_in_anim.isRunning()) hand_in_anim.stop();
		if(hand_out_anim != null && hand_out_anim.isRunning()) hand_out_anim.stop();
	};
	const color = props?.color ?? '#000000';

	const random_cell = Math.round(Math.random());
	const num_rows = 10;
	const initial_w = 4 + random_cell;
	const cell_size = canvas_size / num_rows;
	const initial_x = 3 - random_cell;

	const rows = [{
		width:initial_w,
		x_ini:initial_x,
	}, {
		width:initial_w,
		x_ini:-(initial_w),
		x_end:initial_x + Math.random() * 0.5,
		speed:1,
	}, {
		width:initial_w - 1,
		x_ini:num_rows,
		x_end:initial_x + Math.random() * 0.5,
		speed:0.9,
	}, {
		width:initial_w - 1,
		x_ini:-(initial_w - 1),
		x_end:initial_x + Math.random() * 0.5,
		speed:0.8,
	}, {
		width:initial_w - 2,
		x_ini:num_rows,
		x_end:initial_x + Math.random() * 0.5,
		speed:0.7,
	}, {
		width:initial_w - 2,
		x_ini:-(initial_w - 2),
		x_end:initial_x + Math.random() * 0.5,
		speed:0.6,
	}, {
		width:initial_w - 2,
		x_ini:num_rows,
		x_end:initial_x + Math.random() * 0.5,
		speed:0.55,
	}, {
		width:initial_w - 2,
		x_ini:-(initial_w - 2),
		x_end:initial_x + Math.random() * 0.5,
		speed:0.5,
	}, {
		width:initial_w - 3,
		x_ini:num_rows,
		x_end:initial_x + Math.random() * 0.5,
		speed:0.45,
	}, {
		width:initial_w - 3,
		x_ini:-(initial_w - 3),
		x_end:initial_x + Math.random() * 0.5,
		speed:0.4,
	}];

	const animateRow = (index) => {
		if(refs.current[`row_${index}`] == undefined) return;

		refs.current[`row_${index}`].to({
			x:cell_size * rows[index].x_end,
			duration:1 * rows[index].speed,
			onFinish:() => {
				if(refs.current['hand'] == undefined) return;

				refs.current['hand'].clickingHandOn();

				setTimeout(() => {
					if(refs.current['hand'] == undefined) return;

					refs.current['hand'].clickingHandOff();
	
					if(index < rows.length - 1) {
						animateRow(index + 1);
					} else {
						setTimeout(() => {
							moveHandOut();
						}, 500);
					}
				}, 100);
			},
		});
	};

	const moveHandIn = () => {
		if(refs.current['hand_ref'] == undefined) return false;

		hand_in_anim = refs.current['hand_ref'].to({
			duration:0.6,
			x:0.8 * canvas_size,
			y:0.8 * canvas_size,
			easing:Konva.Easings.StrongEaseOut,
			onFinish:() => {
				animateRow(1);
			},
		});
	};

	const moveHandOut = () => {
		if(refs.current['hand_ref'] == undefined) return false;

		hand_out_anim = refs.current['hand_ref'].to({
			duration:0.8,
			x:1.2 * canvas_size,
			y:1.2 * canvas_size,
			easing:Konva.Easings.StrongEaseOut,
			onFinish:() => {
				setTimeout(() => {
					resetAnimation();
				}, 500);
			},
		});
	};

	const resetAnimation = () => {
		rows.map((row, r) => {
			if(r == 0) return null;

			refs.current[`row_${r}`].setAttrs({
				x:cell_size * row.x_ini,
			});
		});

		refs.current['layer'].draw();

		setTimeout(() => {
			moveHandIn();
		}, 500);
	};

	useEffect(() => {
		moveHandIn();

		return () => {
			killAllFrameAnimations();
			refs.current['whole_instructions_ref'].destroyChildren();
		}
	}, []);

	return (
		<div style={{ width:`${canvas_size}px`, height:`${canvas_size}px` }}>
			<Stage
				ref={(node) => { refs.current['whole_instructions_ref'] = node; }}
				width={canvas_size}
				height={canvas_size}
			>
				<Layer
					ref={(node) => { refs.current['layer'] = node; }}
				>
					<Rect
						width={canvas_size - 2}
						height={canvas_size - 2}
						x={1}
						y={1}
						stroke={color}
						strokeWidth={2}
					/>

					{rows.map((row, r) => {
						return (
							<Rect
								key={`row_${r}`}
								ref={(node) => { refs.current[`row_${r}`] = node; }}
								width={row.width * cell_size}
								height={cell_size}
								fill={color}
								x={cell_size * row.x_ini}
								y={canvas_size - (1 + r) * cell_size}
							/>
						)
					})}

					<Group
						ref={(node) => { refs.current['hand_ref'] = node; }}
						x={1.2 * canvas_size}
						y={1.2 * canvas_size}
					>
						<InstructionsHand
							ref={(node) => { refs.current['hand'] = node; }}
							scale={0.7}
						/>
					</Group>
				</Layer>
			</Stage>
		</div>
	)
}

export default StackItInstructionsCanvas;